import {isUndefined} from 'lodash-es'
// 金额千分位加逗号
const moneyFormat = function (num) {
  // 如果是已经做过处理的，则不做二次处理
  if (!num && Number(num) !== 0) {
    num = ''
    return
  } else if (isNaN(num)) {
    return num
  }
  if (typeof num === 'string' && num.includes(',')) {
    num = num.replace(/,/g, '')
  }
  // 千分位
  if (num === null || num === undefined || num === '') return ''
  return num.toString().replace(/\d+/, (n) => {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
      // 对整数部分添加分隔符
      return $1 + ','
    })
  })
}

function _integer (a, b) {
  let [a0 = '', a1 = ''] = a.split('.')
  let [b0 = '', b1 = ''] = b.split('.')
  const maxA = Math.max(a0.length, b0.length)
  const maxB = Math.max(a1.length, b1.length)
  // 整数向前补0
  a0 = a0.padStart(maxA, '0').replace(/\./, '')
  b0 = b0.padStart(maxA, '0').replace(/\./, '')
  // 小数向后补0
  a1 = a1.padEnd(maxB, '0').replace(/\./, '')
  b1 = b1.padEnd(maxB, '0').replace(/\./, '')
  return [a0 + a1, b0 + b1]
}

//从字符截取数字
function getMidNum (str, start, len) {
  if (start + len > 0) {
    return +str.substr(start < 0 ? 0 : start, start < 0 ? start + len : len)
  }
  return 0
}

//比较两个大整数的大小，返回－1，0，1
function compare (a, b) {
  let back = 0
  //小数需要补 0
  const pos = Math.max(_index(a), _index(b))
  // 如果有小数
  if (pos !== 0) {
    [a, b] = _integer(a, b)
  }
  let max = Math.ceil(Math.max(a.length, b.length) / 15)
  //分成多少段,从左边开始
  for (let i = max; i > 0; i--) {
    const num1 = getMidNum(a, a.length - i * 15, 15)
    const num2 = getMidNum(b, b.length - i * 15, 15)
    //15位数字相减
    let cur = num1 - num2
    if (cur < 0) {
      back = -1
      break
    } else if (cur > 0) {
      back = 1
      break
    }
  }
  return back
}

const _index = (str) => {
  str = typeof str === 'number' ? JSON.stringify(str) : str
  if (str.indexOf('.') > -1) {
    return str.length - str.indexOf('.') - 1
  }
  return 0
}

/*大数相加
 *   1、整数的精度是Math.pow(2,53),大于 9007199254740992 的可能会丢失精度,所以相加的字符长度为15位。
 *   2、负数＋负数、负数＋正数、正数＋负数的情况
 * */
function addNum (a, b) {
  if (a[0] === '-' && b[0] === '-') {
    return '-' + addNum(a.substr(1), b.substr(1))
  }
  if (a[0] === '-') {
    return subNum(b, a.substr(1))
  }
  if (b[0] === '-') {
    return subNum(a, b.substr(1))
  }

  //小数需要补 0
  const pos = Math.max(_index(a), _index(b))
  // 如果有小数
  if (pos !== 0) {
    [a, b] = _integer(a, b)
    const res = _add(a, b)
    return (res.slice(0, res.length - pos) || '0') + '.' + res.slice(res.length - pos)
  }
  return _add(a, b)
}

function _add (a, b) {
  let res = ''
  let temp = 0

  let len1 = a.length
  let len2 = b.length
  let n = Math.ceil(Math.max(len1, len2) / 15)
  //分成多少段
  for (let i = 1; i < n + 1; i++) {
    const num1 = getMidNum(a, len1 - i * 15, 15)
    const num2 = getMidNum(b, len2 - i * 15, 15)
    //15位数字相加
    let strTemp = String(temp + num1 + num2)
    if (i !== n) {
      //异常1:处理000000000000000＋整数的异常情况
      if (strTemp.length < 15) {
        strTemp = '0'.repeat(15 - strTemp.length) + strTemp
        res = strTemp + res
        temp = 0
        continue
      }
      //异常2:15位相加等于16位
      if (strTemp.length === 16) {
        res = strTemp.substr(1, 15) + res
        temp = 1
        continue
      }
    }
    //相加后的结果放入res前面
    res = strTemp + res
    temp = 0
  }
  return res
}

//大数相减，处理 负数-负数、负数－正数、正数－负数的情况
function subNum (a, b) {
  if (a[0] === '-' && b[0] === '-') {
    return subNum(b.substr(1), a.substr(1))
  }
  if (a[0] === '-') {
    return '-' + addNum(a.substr(1), b)
  }
  if (b[0] === '-') {
    return addNum(a, b.substr(1))
  }
  let symb = ''
  // 如果 b 大于 a 最后结果为负数
  if (compare(a, b) < 0) {
    symb = '-'
    const cache = a
    a = b
    b = cache
  }
  const pos = Math.max(_index(a), _index(b))
  // 如果有小数
  if (pos !== 0) {
    [a, b] = _integer(a, b, symb)
    const res = _sub(a, b)
    // 返回都是小数
    if (res.length - pos <= 0) {
      return symb + '0.' + res.padStart(pos, '0')
    }
    // 整数小数都有
    return (
      symb +
      res.slice(0, res.length - pos) + '.' + res.slice(res.length - pos).padStart(pos, '0')
    )
  }
  return symb + _sub(a, b, symb)
}

function _sub (a, b) {
  let res = ''
  let temp = 0

  let n = Math.ceil(a.length / 15)
  //分成多少段
  for (let i = 1; i < n + 1; i++) {
    const num1 = getMidNum(a, a.length - i * 15, 15)
    const num2 = getMidNum(b, b.length - i * 15, 15)
    //15位数字相减
    let tempNum = num1 - num2 - temp
    if (tempNum < 0) {
      temp = 1
      tempNum = 1000000000000000 + tempNum
    } else {
      temp = 0
    }
    let strTemp = String(tempNum)

    if (i !== n) {
      //异常1:处理000000000000000＋整数的异常情况
      if (strTemp.length < 15) {
        strTemp = '0'.repeat(15 - strTemp.length) + strTemp
      }
    }
    //相加后的结果放入res前面
    res = strTemp + res
  }
  return res
}

function _toString (value) {
  return isUndefined(value) ? '' : String(value)
}

export {_toString, compare, subNum, addNum, moneyFormat}
